import { render, staticRenderFns } from "./manageUpdata.vue?vue&type=template&id=453c2a81&scoped=true&"
import script from "./manageUpdata.vue?vue&type=script&lang=js&"
export * from "./manageUpdata.vue?vue&type=script&lang=js&"
import style0 from "./manageUpdata.vue?vue&type=style&index=0&id=453c2a81&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../ytht-h5/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453c2a81",
  null
  
)

export default component.exports